import React, { useState } from "react";
import ProcedureForm from "../components/ProcedureForm";
import ProcedureDetails from "../components/ProcedureDetails";

const ProcedureMaster = () => {
  const [procedures, setProcedures] = useState([
    {
      id: "1",
      procedureCode: "PROC-001",
      procedureName: "Appendectomy",
      departmentID: "General Surgery",
      baseCost: 15000,
      additionalCosts: ["Consumables - ₹2000", "Nursing - ₹3000"],
      preProcedureChecklist: ["Blood Test", "ECG"],
      postProcedureCare: ["Antibiotics", "Follow-up in 7 days"],
      requiredResources: ["OT", "General Ward"],
      insuranceMapping: ["Insurance-A - 80% coverage"],
    },
  ]);
  const [selectedProcedure, setSelectedProcedure] = useState(null);
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [isDetailsOpen, setIsDetailsOpen] = useState(false);

  const handleAddOrEdit = (procedure) => {
    if (procedure.id) {
      setProcedures((prev) =>
        prev.map((p) => (p.id === procedure.id ? procedure : p))
      );
    } else {
      setProcedures((prev) => [...prev, procedure]);
    }
    setIsFormOpen(false);
  };

  const handleDelete = (id) => {
    setProcedures((prev) => prev.filter((p) => p.id !== id));
  };

  const departments = [
    { id: "dept001", name: "General Surgery" },
    { id: "dept002", name: "Cardiology" },
  ];

  const labTests = [
    { id: "test001", name: "Blood Test" },
    { id: "test002", name: "ECG" },
  ];

  const medicines = [
    { id: "med001", name: "Paracetamol" },
    { id: "med002", name: "Amoxicillin" },
  ];

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      {/* Header Section */}
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-bold text-black">Procedure Master</h1>
        <button
          onClick={() => {
            setSelectedProcedure(null);
            setIsFormOpen(true);
          }}
          className="text-black px-4 py-2 rounded-lg hover:bg-opacity-90 shadow"
          style={{ backgroundColor: "#c7eac9", color: "black" }}
        >
          Add Procedure
        </button>
      </div>

      {/* Procedure Table */}
      <div className="overflow-hidden rounded-lg shadow-lg bg-white">
        <table className="table-auto w-full text-left">
          <thead>
            <tr className="bg-gray-200 text-gray-700">
              <th className="px-6 py-3">Procedure Name</th>
              <th className="px-6 py-3">Code</th>
              <th className="px-6 py-3">Department</th>
              <th className="px-6 py-3">Base Cost</th>
              <th className="px-6 py-3">Actions</th>
            </tr>
          </thead>
          <tbody>
            {procedures.map((procedure, index) => (
              <tr
                key={procedure.id}
                className={`${
                  index % 2 === 0 ? "bg-gray-100" : "bg-white"
                } hover:bg-gray-50`}
              >
                <td className="px-6 py-3">{procedure.procedureName}</td>
                <td className="px-6 py-3">{procedure.procedureCode}</td>
                <td className="px-6 py-3">{procedure.departmentID}</td>
                <td className="px-6 py-3">₹{procedure.baseCost}</td>
                <td className="px-6 py-3 flex gap-2">
                  <button
                    onClick={() => {
                      setSelectedProcedure(procedure);
                      setIsDetailsOpen(true);
                    }}
                    className="text-black px-3 py-1 rounded-lg hover:bg-opacity-90 shadow"
                    style={{ backgroundColor: "#c7eac9" }}
                  >
                    View
                  </button>
                  <button
                    onClick={() => {
                      setSelectedProcedure(procedure);
                      setIsFormOpen(true);
                    }}
                    className="bg-yellow-500 text-white px-3 py-1 rounded-lg hover:bg-yellow-600 shadow"
                  >
                    Edit
                  </button>
                  <button
                    onClick={() => handleDelete(procedure.id)}
                    className="bg-red-500 text-white px-3 py-1 rounded-lg hover:bg-red-600 shadow"
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Modals */}
      {isFormOpen && (
        <ProcedureForm
          departments={departments}
          labTests={labTests}
          medicines={medicines}
          procedure={selectedProcedure}
          onClose={() => setIsFormOpen(false)}
          onSave={handleAddOrEdit}
        />
      )}

      {isDetailsOpen && (
        <ProcedureDetails
          procedure={selectedProcedure}
          onClose={() => setIsDetailsOpen(false)}
        />
      )}
    </div>
  );
};

export default ProcedureMaster;
